import {Routes} from '@angular/router';

import {LoginComponent} from './auth/login.component';
import {DateComponent} from './main/date.component';
import {WeekComponent} from './main/week.component';

import {AccountComponent} from './account/account.component';

import {UsersOnly, GuestsOnly} from './auth/guard.service';

export const routes : Routes = [
    { path: 'login', component: LoginComponent, canActivate: [GuestsOnly] },
    { path: '', redirectTo: 'date/today', pathMatch: 'full', canActivate: [UsersOnly] },
    { path: 'today', redirectTo: 'date/today', pathMatch: 'full', canActivate: [UsersOnly] },
    { path: 'date/:date', component: DateComponent, canActivate: [UsersOnly] },
    { path: 'week/:week', component: WeekComponent, canActivate: [UsersOnly] },
    { path: 'week', component: WeekComponent, canActivate: [UsersOnly] },
    { path: 'account', component: AccountComponent, canActivate: [UsersOnly] },
]



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/routes.ts